import {GameInfo} from "../../../games/game-info";
import {Check} from "@sparkware/app-utils";
import {GameFeatureFilterDefinitionBase} from "../game-feature-filter-definition-base";

export class TwentyFivePlusFilterDefinition extends GameFeatureFilterDefinitionBase {
    get id(): string {
        return "twenty-five-plus";
    }

    get text(): string {
        return this.services.translation.translate('25+_LINES');
    }

    protected _shouldIncludeGame(gameInfo: GameInfo): boolean {
        return Check.isNumber(gameInfo.numberOfLines) && gameInfo.numberOfLines >= 25;
    }
}